import styled from 'styled-components';

export const Container = styled.div`
  display: block;
  gap: 10px;
`;

export const MerchantList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(284px, 1fr));
  gap: 16px;
`;

export const MerchantInfo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
